import React from 'react';
import { Box, Skeleton } from '@mui/material';
import './SkeletonEffect.css';

const TransactionHistorySkeleton = ({ count = 3 }) => {
  return (
    <Box className="transaction-history-skeleton-container">
      {Array.from({ length: count }).map((_, index) => (
        <Box key={index} className="transaction-history-skeleton-item">
          <Box className="transaction-history-skeleton-content">
            <Box className="transaction-history-skeleton-icon">
              <Skeleton variant="circular" width={32} height={32} />
            </Box>
            <Box className="transaction-history-skeleton-text">
              <Skeleton
                variant="text"
                width={120}
                height={20}
                className="transaction-history-skeleton-title"
              />
              <Skeleton
                variant="text"
                width={180}
                height={16}
                className="transaction-history-skeleton-date"
              />
            </Box>
          </Box>
          <Skeleton
            variant="text"
            width={60}
            height={24}
            className="transaction-history-skeleton-amount"
          />
        </Box>
      ))}
    </Box>
  );
};

export const DashboardStatsSkeleton = () => {
  return (
    <Box className="dashboard-stats-skeleton-container">
      {Array.from({ length: 4 }).map((_, index) => (
        <Box key={index} className="dashboard-stats-skeleton-card">
          <Skeleton
            variant="text"
            height={18}
            width={120}
            className="dashboard-stats-skeleton-line"
          />
          <Box mt={1.5}>
            <Skeleton
              variant="text"
              height={32}
              width={140}
              className="dashboard-stats-skeleton-line"
            />
          </Box>
          <Box mt={1}>
            <Skeleton
              variant="text"
              height={14}
              width={100}
              className="dashboard-stats-skeleton-line"
            />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export const RevenueSectionSkeleton = () => {
  return (
    <Box className="revenue-skeleton-card">
      <Skeleton variant="text" className="dashboard-stats-skeleton-line revenue-skeleton-title" />
      <Box className="revenue-skeleton-chart" />
    </Box>
  );
};

export const UpcomingSessionsSkeleton = ({ rows = 4 }) => {
  return (
    <Box className="w-full">
      <Skeleton variant="text" height={24} width={200} className="dashboard-stats-skeleton-line" />
      <Box mt={2}>
        {Array.from({ length: rows }).map((_, index) => (
          <Box key={index} mb={1.5} p={1.5} sx={{ background: '#fff', borderRadius: '12px' }}>
            <Skeleton
              variant="text"
              height={18}
              width="50%"
              className="dashboard-stats-skeleton-line"
            />
            <Box mt={1} display="flex" justifyContent="space-between" alignItems="center">
              <Skeleton
                variant="text"
                height={14}
                width="30%"
                className="dashboard-stats-skeleton-line"
              />
              <Skeleton
                variant="text"
                height={14}
                width="20%"
                className="dashboard-stats-skeleton-line"
              />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default TransactionHistorySkeleton;
